import { Typography } from '@weareopenr/component-library';
import { getTotalExcludedCategories } from '../getTotalExcludedCategories/getTotalExcludedCategories';
import { IMealtime } from 'src/types/mealtimes.types';
import { ISection } from 'src/types/menu.types';
import styles from '../SummaryView.module.scss';

export const getMealtimesSubtitle = (
  mealtimes: IMealtime[],
  categories: ISection[],
  isMealtimeOptionEnabled: boolean,
): string | JSX.Element => {
  if (!mealtimes.length || !isMealtimeOptionEnabled) {
    return 'Default: Opening Hours';
  }

  const totalMealtimes = `${mealtimes.length} ${mealtimes.length > 1 ? 'Mealtimes' : 'Mealtime'}`;

  const excludedTotalCategories = getTotalExcludedCategories(mealtimes, categories);

  return !excludedTotalCategories ? (
    totalMealtimes
  ) : (
    <Typography>
      {`${totalMealtimes} / `}
      <span className={styles['excluded-categories']}>{`${excludedTotalCategories} Unassigned ${
        excludedTotalCategories > 1 ? 'Categories' : 'Category'
      }`}</span>
    </Typography>
  );
};
